<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="list-row">
    <v-card
        class="clickable"
        v-if="display==='list'"
        @click="$store.commit('dialog_is_product',{toggle:true,index:currentIndex})"
    >
      <ProductRowList :product="product" :onClickAddCart="onClickAddCart"></ProductRowList>
    </v-card>
    <v-card
        v-if="display==='column2'"
        @click="$store.commit('dialog_is_product',{toggle:true,index:currentIndex})"
    >
      <ProductRowColumn2 :product="product" :onClickAddCart="onClickAddCart"></ProductRowColumn2>
    </v-card>
    <v-card
        v-if="display==='grid'"
        @click="$store.commit('dialog_is_product',{toggle:true,index:currentIndex})"
    >
      <ProductRowGrid :product="product" :onClickAddCart="onClickAddCart"></ProductRowGrid>
    </v-card>
  </div>

</template>
<style lang="scss" scoped>
  .stock {
    font-size: 20px;
  }

  .unit {
    font-size: 0.5em;
  }

  .percent {
    font-size: 0.7em;
  }

  .currency {
    /*display: block;*/
    /*width: 32px;*/
    /*float: right;*/
    font-size: 0.7em;
  }

</style>

<script lang="ts">

  import {Component, Prop, Vue} from 'vue-property-decorator'
  import {Product} from '../../models/Product'
  import router from '../../router'
  import ProductRowColumn2 from './ProductRowColumn2.vue'
  import ProductRowGrid from './ProductRowGrid.vue'
  import ProductRowList from './ProductRowList.vue'

  @Component({
    components: {ProductRowColumn2, ProductRowList, ProductRowGrid},
  })
  export default class ProductRow extends Vue {
    @Prop() product: Product
    @Prop() currentIndex: number
    @Prop({default: 'list'}) display: string

    async onClickAddCart(product: Product, delta = 1) {

      if (this.$store.state.carts.current.id) {
        const item = await this.$store.dispatch('alter_item_to_cart', {product, delta})

        if (item instanceof Error) {
          const e: any = item
          console.log(e.response.data)
          if (e.response && e.response.data && e.response.data.message)
            this.$root.$emit('onWarning', {message: e.response.data.message, error: e})
          else
            this.$root.$emit('onError', {error: e})
          return
        }

      } else {
        this.$root.$emit('onWarning',{message:"กรุณาเลือกลูกค้าก่อนสั่งสินค้า"})
        router.push('/customer')
      }
    }
  }

</script>
